export default __webpack_public_path__ + "media/music/e4aa748aa486780847b6d1a1af3ecdf5.mp3";